<template>
	<div class="form-row step-row justify-content-center">
		<div
			class="
				step-items-wrapper
				scrollable-list
				form-row
				justify-content-center
			"
		>
			<template v-for="item in items">
				<div class="step-item" v-bind:key="item.value">
					<button
						class="btn btn-list btn-lg form-control"
						v-bind:class="{
							active:
								item.value === selectedValue ||
								(selectedValue === null &&
									item.value === value),
						}"
						v-on:click="click(item.value)"
					>
						{{ item.text }}
					</button>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	name: "ScrollableButtonList",
	data: function () {
		return {
			selectedValue: null,
		};
	},
	methods: {
		click: function (value) {
			this.selectedValue = value;
			this.onclick(value);
		},
	},
	props: {
		items: Array,
		value: null,
		onclick: Function,
	},
};
</script>

<style scoped>
.scrollable-list {
	width: 100%;
	display: flex;
}
.scrollable-list .step-item {
	width: 20%;
}
.scrollable-list .step-item .btn-step {
	vertical-align: middle;
	width: 100%;
	height: 62px;
	line-height: 62px;
	background: #00cc6e;
	border-radius: 5px;
	color: #fff;
	font-size: 24px;
	text-align: center;
	font-weight: bold;
	margin-top: 0px;
	padding: 0;
}

.btn.active {
	text-decoration: underline;
}

@media (max-width: 767px) {
	.scrollable-list .step-item {
		width: 50%;
	}
}
</style>
